export const ASPECT_RATIO_PATTERN = /^\d+(?:\.\d+)?\s*:\s*\d+(?:\.\d+)?$/;

export const validateSpreadLayoutForm = (data) => {
  const aspect = String(data.layout_aspect_ratio || '').trim();
  if (data.layout_mode === 'spread' && !aspect) {
    return 'Aspect ratio is required for spread layout (e.g. 2:1).';
  }
  if (aspect && !ASPECT_RATIO_PATTERN.test(aspect)) {
    return 'Aspect ratio must be in W:H format (e.g. 1:1, 3:4, 2:1).';
  }
  const wide = String(data.layout_wide_ratio || '').trim();
  if (wide && !ASPECT_RATIO_PATTERN.test(wide)) {
    return 'Wide fallback ratio must be in W:H format (e.g. 16:9), or left empty.';
  }
  return '';
};

export const buildLayoutPayload = (data) => {
  const payload = {
    layout_mode: data.layout_mode === 'spread' ? 'spread' : 'single',
    line_art: data.line_art === true,
  };
  const targetAspect = String(data.layout_aspect_ratio || '').trim();
  if (targetAspect) {
    payload.scene_geometry = { aspect_ratio: targetAspect };
    if (data.layout_resolution) {
      payload.scene_geometry.resolution = data.layout_resolution;
    }
    const wideRatio = String(data.layout_wide_ratio || '').trim();
    if (wideRatio) {
      payload.scene_geometry.wide_ratio = wideRatio;
    }
  } else {
    payload.scene_geometry = null;
  }
  return payload;
};
